import { useEffect } from 'react';

import { useFetch } from 'hooks/useAsync';

import * as productServices from 'services/product';

export const useFetchProductDetail = ({ productId }) => {
  const { data, run, status } = useFetch();

  useEffect(() => {
    if (productId)
      run(productServices.getProductFullView({ productItemId: productId }));
  }, [productId, run]);

  return {
    productDetail: data?.data ?? {},
    isLoading: status === 'pending',
  };
};
